exports.components = {
  "component---src-pages-entropy-js": () => import("./../../../src/pages/entropy.js" /* webpackChunkName: "component---src-pages-entropy-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-logo-design-js": () => import("./../../../src/pages/logo-design.js" /* webpackChunkName: "component---src-pages-logo-design-js" */)
}

